export const AUTO_LOGIN_CODE_KEY = 'bznav_refund_auto_login_code';
